import { useNavigate } from "react-router-dom";

export default function Continue() {
    const navigate = useNavigate();

    const handleCheckout = () => {
        navigate('/order-summary');
    };

    return (
        <button
            onClick={handleCheckout}
            style={{
                marginRight: "2%",
                width: "40%",
                height: "80%",
                border: "2px solid white",
                borderRadius: "10px",
                color: "white",
                backgroundColor: "rgba(0, 0, 0, 0.7)",
                pointerEvents: "auto"
            }}
        >
            Continue
        </button>
    );
}
